import {Component, ViewChild} from '@angular/core';
import {Content, IonicPage, NavParams, ViewController} from 'ionic-angular';
import {AppConfig} from '../../../../../app/app.config';
import {
  JackingMergeChoice,
  JackingMergeConflict,
  JackingMergeIncomingChange
} from '../../../../../services/jacking-v2/jacking-three-way-merge.service';

@IonicPage()
@Component({
  selector: 'page-jacking-merge-modal',
  templateUrl: 'jacking-merge-modal.component.html'
})
export class JackingMergeModalComponent {
  @ViewChild(Content) content: Content;

  config = AppConfig.settings;
  conflicts: JackingMergeConflict[] = [];
  incomingChanges: JackingMergeIncomingChange[] = [];
  choices: {[conflictId: string]: JackingMergeChoice} = {};

  constructor(private navParams: NavParams, private viewCtrl: ViewController) {}

  ngOnInit(): void {
    this.conflicts = this.navParams.get('conflicts') || [];
    this.incomingChanges = this.navParams.get('incomingChanges') || [];
    this.selectAll('mine');
  }

  ionViewDidEnter(): void {
    // Ionic writes the header/footer margins before the modal transition. Chromium can retain
    // the scroll element's pre-margin height until a viewport reflow, which is why resizing the
    // browser fixes the overlap. Recreate just that layout box once the transition has finished.
    const scrollElement = this.content.getScrollElement();
    const inlineDisplay = scrollElement.style.display;
    scrollElement.style.display = 'none';
    void scrollElement.offsetHeight;
    scrollElement.style.display = inlineDisplay;
  }

  get hasConflicts(): boolean {
    return this.conflicts.length > 0;
  }

  get hasIncomingChanges(): boolean {
    return this.incomingChanges.length > 0;
  }

  get hasMixedChanges(): boolean {
    return this.hasConflicts && this.hasIncomingChanges;
  }

  get modalTitle(): string {
    if (this.hasMixedChanges) {
      return 'Review concurrent changes';
    }
    return this.hasConflicts ? 'Resolve change conflicts' : 'Review incoming changes';
  }

  get footerActionLabel(): string {
    if (this.hasMixedChanges) {
      return 'Apply selections and accept incoming changes';
    }
    return this.hasConflicts ? 'Apply and continue' : 'Accept changes and continue';
  }

  selectAll(choice: JackingMergeChoice): void {
    this.conflicts.forEach(conflict => this.choices[conflict.id] = choice);
  }

  selectChoice(conflictId: string, choice: JackingMergeChoice, event?: MouseEvent): void {
    if (event && this.hasTextSelectionWithin(event.currentTarget as Node)) {
      return;
    }
    this.choices[conflictId] = choice;
  }

  private hasTextSelectionWithin(container: Node): boolean {
    const selection = window.getSelection ? window.getSelection() : null;
    if (!selection || selection.isCollapsed || !selection.toString()) {
      return false;
    }

    const anchorIsInside = !!selection.anchorNode && container.contains(selection.anchorNode);
    const focusIsInside = !!selection.focusNode && container.contains(selection.focusNode);
    return anchorIsInside || focusIsInside;
  }

  close(): void {
    this.viewCtrl.dismiss({applied: false});
  }

  apply(): void {
    this.viewCtrl.dismiss({applied: true, choices: {...this.choices}});
  }
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/jacking-merge-modal/jacking-merge-modal.component.ts